import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../../data/mock';
import { Linkedin, Instagram, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-brand-petrol text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="col-span-1 sm:col-span-2">
            <img
              src={siteConfig.logoUrlLight}
              alt={siteConfig.name}
              className="h-16 md:h-20 w-auto mb-4 object-contain"
             loading="lazy" decoding="async" />
            <p className="text-white/60 mt-2 max-w-md text-sm md:text-base font-display italic text-lg">
              {siteConfig.tagline}
            </p>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-medium mb-4 text-brand-terracotta-light">
              Navigation
            </h4>
            <ul className="space-y-2">
              {[
                ['/', 'Accueil'],
                ['/qui-sommes-nous', 'Qui sommes nous ?'],
                ['/groupe', 'Le Groupe'],
                ['/notre-offre', 'Notre offre'],
                ['/team-building', 'Team building'],
                ['/afterwork', 'Afterwork'],
                ['/seminaire-entreprise', 'Séminaire'],
                ['/contact', 'Contact'],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-white/55 hover:text-brand-terracotta-light transition-colors text-sm md:text-base"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-medium mb-4 text-brand-terracotta-light">
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center text-white/55">
                <Mail className="h-4 w-4 mr-2 text-brand-terracotta-light flex-shrink-0" strokeWidth={1.5} />
                <a href="mailto:contact@monevenemenciel.eu" className="hover:text-white transition-colors text-sm break-all">
                  contact@monevenemenciel.eu
                </a>
              </li>
              <li className="flex items-center text-white/55">
                <Phone className="h-4 w-4 mr-2 text-brand-terracotta-light flex-shrink-0" strokeWidth={1.5} />
                <a href="tel:+33612938463" className="hover:text-white transition-colors text-sm">
                  +33 6 12 93 84 63
                </a>
              </li>
            </ul>
            <div className="flex space-x-4 mt-6">
              <a
                href="https://www.linkedin.com/company/mon-evenemenciel"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/45 hover:text-brand-terracotta-light transition-colors"
              >
                <Linkedin className="h-5 w-5" strokeWidth={1.5} />
              </a>
              <a
                href="https://www.instagram.com/monevenemenciel/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/45 hover:text-brand-terracotta-light transition-colors"
              >
                <Instagram className="h-5 w-5" strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-xs md:text-sm">
            © 2025 {siteConfig.name}. Tous droits réservés.
          </p>
          <div className="flex space-x-6">
            <Link to="/mentions-legales" className="text-white/40 hover:text-white text-xs md:text-sm transition-colors">
              Mentions légales
            </Link>
            <Link to="/confidentialite" className="text-white/40 hover:text-white text-xs md:text-sm transition-colors">
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
